export const calculateExchangeRateDeviation = (
  paymentAmount: number,
  exchangeRate: number,
  targetAmount: number,
): number => {
  if (targetAmount === 0) {
    return 0
  }
  const calculatedExchangeRate = targetAmount / paymentAmount

  return (Math.abs(calculatedExchangeRate - exchangeRate) / exchangeRate) * 100
}
